import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";

import { RegistrationConfigService } from "../registration.config";

import { DataLookUpResponse } from "./data-lookup-level.model";

@Injectable({
	providedIn: "root",
})
export class DataLookupLevelService {
	constructor(
		private httpClient: CoreHttpClient,
		private registrationConfig: RegistrationConfigService
	) {}

	getDataLookupLevel(transactionId: string) {
		return this.httpClient.get<DataLookUpResponse>({
			url: this.registrationConfig.getDataLookupLevelEndpoint(),
			searchParams: { transactionId },
		});
	}
}
